import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "../App.css";
import "./Content.css";
import VideoPage from "./VideoPage";
import { useMsal } from "@azure/msal-react";
// import SSOLogin from '../SSOLogin';
import { baseUrl } from "../Constant";
import axios from "axios";
function Content() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const AdminUsers = [
    "reshmi.haridas.m",
    "h.srinivasan",
    "varsha.a.tyagi",
    "jeevadharani.ramanan",
    "aluru.akash",
    "lakshay.c.gupta",
    "aayushi.bharti",
    "uma.rani.battu",
    "j.b.mittal",
    "rashi.shrivastava",
    "arpita.m.singh",
    "ankur.e.mishra",
    "b.prasad.mishra",
  ];
  const [temp, setTemp] = useState("");
  useEffect(() => {
    const homeUrl = async () => {
      const res = await axios.get(`${baseUrl}/homeUrl`, {});
      setTemp(res.data.Url);
    };
    homeUrl();
  }, []);
  return (
    <div className="main-container techexpressway-container">
      <title>Tech Expressway</title>

      <div className="bannerContainer">
        <img src="/images/banner-entry.png" className="banner-img" alt="" />

        <h1 className="sr-only" tabIndex={0}>
          Tech Expressway
        </h1>
        <p className="sr-only">Your road to success</p>
        {/* <h1 class="bannerHead">Tech Expressway</h1>
            <p className='bannerText'>Your road to success</p> */}
      </div>
      {/* <h5 className="dropdown-item-text mb-0">{this.state.user.displayName}</h5> */}
      {/* <h1 className="banner-head"><span>TechExpressway</span> Academy</h1> */}
      <nav className="navbar">
        <div className="navbar-container">
          <ul className="nav-menu">
            <li className="menu-item">
              <a
                activeClassName="is-active"
                className="nav-links"
                href={temp ? temp : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="underline">L&TT Home</span>
              </a>
            </li>
            <li className="nav-item">
              <NavLink
                to="/home"
                className="nav-links is-active"
                activeClassName="is-active"
                exact={true}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/foundation-component"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-links"
                activeClassName="is-active"
              >
                Foundation
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/job-readiness"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-links"
                activeClassName="is-active"
              >
                Job Readiness
              </NavLink>
            </li>
            <li className="nav-item">
              <a
                href="https://atci.techleap.accenture.com"
                className="nav-links"
                target="_blank"
                rel="noopener noreferrer"
              >
                Specialization
              </a>
            </li>
            {/* <li className="nav-item">
                            <NavLink to="/gamification" className="nav-links" activeClassName="is-active" exact={true}>Gamification</NavLink>
                        </li> */}
            <li className="nav-item">
              <NavLink
                to="/techexpressway-faq"
                className="nav-links"
                activeClassName="is-active"
                exact={true}
              >
                FAQs
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/Testimonials"
                className="nav-links"
                activeClassName="is-active"
                exact={true}
              >
                Testimonials
              </NavLink>
            </li>
            {AdminUsers.includes(loggedInEnterpriseId) && (
              <li className="nav-item">
                <NavLink
                  to="/analytics"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Analytics
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </nav>

      <div className="video-content" id="main">
        <div className="video-content-row1">
          <div className="video-content1">
            <h2 tabIndex={0}>
              <span>Entry Level Learning Program </span> Overview{" "}
            </h2>
            <p>
              ENTRY LEVEL LEARNING provides continuous learning and growth
              framework designed to empower Entry Level Hires to build a solid
              and future-ready career in technology. The program consists of
              progressive phases that strengthen foundational knowledge, build
              job-ready technology capabilities, and enable long-term
              professional growth.
              <br />
              <h4>FOUNDATION:</h4> Establishes a baseline across technology and
              business functions, closing any skill gaps.
              <br />
              <h4>JOB READINESS:</h4> Focuses on hands-on learning in an
              assigned technology/functional skill while equipping learners with
              Delivery and Professional Development skills.
              {/* ENTRY LEVEL LEARNING provides an end-to-end continuous learning
              and growth framework for our Entry Level Hires as they aspire to
              build a career in technology. Spanning a total of 24 months, this
              program has distinct phases, as illustrated below. The first two
              phases - FOUNDATION and JOB READINESS constitute the{" "}
              <h4>PRE-JOINING LEARNING PROGRAM</h4>, disseminating essential
              skills to hires even before they join the organization. The
              FOUNDATION phase ensures a baseline equivalence for all learners
              closing any skill gaps that they may have, with learning
              interventions focused on fundamentals of technology and business
              functions. The JOB READINESS phase, is centered around hands-on
              learning in a specifically assigned technology/functional skill,
              while also equipping the learners with Delivery and Professional
              development skills. Next, ASEs, put their learnings to test and
              attempt myCompetency assessment, earning proficiencies in the
              skill acquired through stream learning. After successful
              completion of Job-readiness phase and onboarding Accenture, ASEs
              proceed on to the SPECIALIZATION phase, building
              full-stack/multi-skill capabilities. */}
              {/* core engineering expertise */}{" "}
            </p>
            {/* <p>ENTRY LEVEL LEARNING provides an end-to-end continuous learning and growth framework for our Entry Level Hires as they aspire to build a career in technology. Spanning a total of 24 months, this program has distinct phases, as illustrated below. The first two phases of FOUNDATION and JOB READINESS constitutes the Pre-Joining Learning Program as it disseminates technology/functional skills to entry level hires before they are onboarded. The FOUNDATION phase ensures a baseline equivalence for all learners closing any skill gaps that they may have, with learning interventions focused on fundamentals of technology and business functions. The next phase, JOB READINESS, is centered around hands-on learning in a specific technology/functional skill, while also equipping them with Delivery and Professional development skills. At the end of JOB READINESS phase, learners are expected to attempt the proficiency assessment on MyCompetency portal, upon achieving the minimum required proficiency level, the hires are onboarded to Accenture. This marks the completion of Pre-Joining Learning Program.
                        In SPECIALIZATION phase, the ASEs proceed to build full stack core engineering expertise. The model also accords new joiners with differentiated merit-based progression opportunities to skill up and move up in their early careers through learning and performance outcomes.</p>
                       {/*  <h2 tabIndex={0}><span>Tech Expressway</span> Overview </h2> */}
            {/* <p>TECH EXPRESSWAY provides an end-to-end continuous learning and growth framework for our ASEs as they join Accenture and aspire to build a career in technology. Spanning a total of 24 months, Tech Expressway has distinct phases, as illustrated below. The FOUNDATION phase ensures a baseline equivalence for all new joiners closing any skill gaps that they may have, with learning interventions focused on fundamentals of technology and business functions. The next phase, JOB READINESS, is centered around experiential learning in a specific technology/functional skill, while also equipping them with Delivery and Professional development skills. And in SPECIALIZATION phase, the ASEs proceed to build full stack core engineering expertise. The model also accords new joiners with differentiated merit-based progression opportunities to skill up and move up in their early careers through learning and performance outcomes.</p> */}
            {/* <p className="know-more">Click on the tiles to know more.</p> */}
          </div>
        </div>
        {/* <div className="video-content-row2">
          <div className="video-content2">
            <br /> <br /> */}
        {/*  <video width="400" height="300" controls>
                        <source src="EntryLevelJourney.mp4" type="video/mp4"></source>
                       </video> */}
        {/* <iframe id="kmsembed-1_0osdm2sz" width="400" height="300" src="https://mediaexchange.accenture.com/media/t/1_bq8239bi?st=0" class="kmsembed" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" referrerPolicy="no-referrer-when-downgrade" frameborder="0" title="Kaltura Player"></iframe>  */}
        {/* <VideoPage />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Content;
